import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { KeycloakService } from '../keycloak/keycloak.service';

let errorCount = 0;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const kc = inject(KeycloakService);
  return next(req).pipe(
    catchError((err) => {
      // 1. Bad request
      if (err.status === 400) {
        let message = 'Bad request!';

        if (typeof err.error === 'string') {
          try {
            const parsed = JSON.parse(err.error);
            message = parsed?.message ?? message;
          } catch {
            message = err?.message ?? message;
          }
        } else if (err.error && typeof err.error === 'object') {
          message = err.error.message ?? message;
        }

        return throwError(() => message);
      }

      // Unauthorized.
      // On login page (wrong login/pw) - login.service shows alert
      // On other pages it means expired session. ReconnectInterceptor processes it.

      if (err.status === 401) {
        if (err.error.message === 'Token missing or invalid') {
          kc.login();
          return EMPTY;
        } else {
          kc.logout();
        }
      }
      console.log(err);

      return throwError(() => err);
    }),
  );
};
